import http from "@/api/http";

const state = {
    resp: Object,
    playInfo: Object,
    currentVideo:String,
    respReport:Object,
}

const mutations = {
    setResp: (state, resp) => {
        state.resp = resp
    },
    setPlayInfo: (state, playInfo) => {
        state.playInfo = playInfo
    },
    setCurrentVideo: (state, videoIdentity) => {
        state.currentVideo = videoIdentity
    },
    setrespReport: (state, respReport) => {
        state.respReport = respReport
    },
    setProgress:(state,progress)=>{
        state.progress = progress
    }
}

const actions = {
    request({commit}, params) {
        let url = '/Course/api/SetDetail'
        return http.post(url, params).then(res => {
            commit('setResp', res)
        })
    },
    requestVideo({commit}, params) {
        let url = '/Course/api/playinfo'
        commit('setCurrentVideo',params.videoIdentity)
        return http.post(url, params).then(res => {
            commit('setPlayInfo', res)
        })
    },
    requestUploadProgress({commit}, params) {
        let courses = state.resp.detail.courses.page.list;
        for (let i = 0; i < courses.length; i++) {
            let v = courses[i]
            if(v.videoIdentity===params.videoIdentity){
                v.progress=params.progress
            }
        }
        commit('setProgress',params.progress)

        let url = '/Course/Progress/Report'
        return http.post(url, params).then(resp=>{
            commit('setrespReport',resp)
        })
    },
    //订阅课
    requestDetail({ commit }, params) {
      let url = '/Course/Subscribe/SetDetail'
      return http.post(url, params).then(res => {
        commit('setResp', res)
      })
    }

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
